import './shellKit.css';

export default function LoadingScreen({ label = 'Loading...' }) {
  return (
    <div className="rs-shell__loading" role="status" aria-live="polite">
      <div className="rs-shell__loading-inner">
        <div className="rs-shell__spinner" aria-hidden />
        <p className="rs-shell__loading-label">{label}</p>
      </div>
    </div>
  );
}
